exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#qoip-form-field-data form {\n  background: #fff;\n  padding: 24px; }\n\nb.qoip-block {\n  display: inline-block;\n  font-weight: bold;\n  width: 120px; }\n\n#qiop-map-component md-select {\n  margin: 0;\n  padding: 0; }\n\n#qoip-map-key {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n#qoip-map-key li {\n  padding: 6px; }\n\n#qoip-map-key li span {\n  background: #fff;\n  display: inline-block;\n  padding: 3px; }\n", ""]);

// exports
